import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';

export const ATTACHMENT_ORIGIN = {
  NONE: 'None',
  CONTROL: 'Control',
  MY_ACCOUNT: 'MyAccount',
  EXTERNAL: 'External',
} as const;

export type AttachmentOrigin =
  (typeof ATTACHMENT_ORIGIN)[keyof typeof ATTACHMENT_ORIGIN];

export interface FileAttachmentTransitionInfo {
  moduleId?: string;
  moduleDefinitionId?: string;
  wave?: number;
  from?: string;
  to?: string;
}

export interface FileAttachmentSummary {
  id: string;
  fileId: string;
  transitionInfo?: FileAttachmentTransitionInfo;
  name?: string;
  extension?: string;
  origin: AttachmentOrigin;
  downloadLink?: string;
  uploaderFullName?: string;
  isUploadedByOwner?: boolean;
  uploadDateUtc?: string;
  customerVisibility: boolean;
  documentType?: DOCUMENT_TYPES;
}
